// extracted by mini-css-extract-plugin
export var chip = "_ps-2";
export var chipBody = "_ps-8";
export var chipHeader = "_ps-9";
export var chipWithKind = "_ps-7";
export var icon = "_ps-3";
export var kind = "_ps-a";
export var remove = "_ps-5";
export var removeIcon = "_ps-6";
export var row = "_ps-0";
export var rowHistorical = "_ps-1";
export var text = "_ps-4";